// One-ad launcher used on the creative cards (/admin/ads → "קריאייטיבים"): any creative —
// a reel or a video already on the Page — with its own text, flow, audience and budget.
// The ad is created PAUSED on Meta; nothing is spent until it's switched on.
import {FC, useState} from 'react'
import {launchReel} from './_requests'

const errMsg = (e: any) => e?.response?.data?.error || e?.message || 'שגיאה'

const LaunchForm: FC<{
  creative: {key: string; headline: string; text: string}
  defaultLink: string
  lookalikes: string[]
  onDone: () => void
}> = ({creative, defaultLink, lookalikes, onDone}) => {
  const [budget, setBudget] = useState(100)
  const [headline, setHeadline] = useState(creative.headline)
  const [primary, setPrimary] = useState(creative.text)
  const [link, setLink] = useState(defaultLink)
  const [destination, setDestination] = useState<'website' | 'lead_form' | 'whatsapp'>('website')
  const [audience, setAudience] = useState<'broad' | 'lal_1' | 'lal_3'>('broad')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const submit = async () => {
    setBusy(true)
    setError('')
    try {
      await launchReel({
        creative_key: creative.key,
        daily_budget: budget,
        headline,
        primary,
        link,
        destination,
        audience,
      })
      onDone()
    } catch (e) {
      setError(errMsg(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className='d-grid gap-2 mt-2'>
      <label className='fs-8 text-muted mb-0'>כותרת</label>
      <input
        className='form-control form-control-sm'
        value={headline}
        onChange={(e) => setHeadline(e.target.value)}
      />
      <label className='fs-8 text-muted mb-0'>טקסט המודעה</label>
      <textarea
        className='form-control form-control-sm'
        rows={6}
        value={primary}
        onChange={(e) => setPrimary(e.target.value)}
      />
      <label className='fs-8 text-muted mb-0'>לאן הלחיצה מובילה</label>
      <select
        className='form-select form-select-sm'
        value={destination}
        onChange={(e) => setDestination(e.target.value as any)}
      >
        <option value='website'>דף הרשמה (גוגל / פייסבוק בלחיצה)</option>
        <option value='lead_form'>טופס של פייסבוק — החשבון נפתח אוטומטית</option>
        <option value='whatsapp'>פתיחת וואטסאפ — הבוט פותח חשבון בצ׳אט</option>
      </select>
      {destination === 'website' && (
        <>
          <label className='fs-8 text-muted mb-0'>קישור (פרמטרי מעקב מתווספים אוטומטית)</label>
          <input
            className='form-control form-control-sm'
            dir='ltr'
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </>
      )}
      <label className='fs-8 text-muted mb-0'>קהל</label>
      <select
        className='form-select form-select-sm'
        value={audience}
        onChange={(e) => setAudience(e.target.value as any)}
      >
        <option value='broad'>רחב — Advantage+ (פייסבוק מוצא לבד)</option>
        {lookalikes.includes('lal_1') && (
          <option value='lal_1'>Lookalike 1% של הלקוחות המשלמים</option>
        )}
        {lookalikes.includes('lal_3') && (
          <option value='lal_3'>Lookalike 3% של הלקוחות המשלמים</option>
        )}
      </select>
      <label className='fs-8 text-muted mb-0'>תקציב יומי ₪</label>
      <input
        type='number'
        className='form-control form-control-sm'
        value={budget}
        min={20}
        onChange={(e) => setBudget(Number(e.target.value))}
      />
      <div className='fs-8 text-muted'>
        ישראל · גילאי 25–65 · לקוחות קיימים מוחרגים · אופטימיזציה להרשמות. נוצר במצב מושהה — לא יוצא
        כסף עד שמפעילים.
      </div>
      {error && <div className='alert alert-danger py-2 mb-0 fs-7'>{error}</div>}
      <button className='btn btn-sm btn-primary' disabled={busy} onClick={submit}>
        {busy ? 'יוצר…' : 'צור מודעה (מושהית)'}
      </button>
    </div>
  )
}

export default LaunchForm
